import { Checkbox } from '@bechtel/gds';
import { FC, memo, useState } from 'react';

export interface CheckboxProps {
  onChange: (status: boolean) => void;
  checked: boolean;
  disabled: boolean;
}
export const CheckboxView: FC<CheckboxProps> = memo(({ onChange, checked, disabled }) => {
  const [isActive, setIsActive] = useState<boolean>(checked);

  return (
    <Checkbox
      checked={checked || isActive}
      disabled={disabled}
      onChange={() => {
        setIsActive(!isActive);
        onChange(!isActive);
      }}
    />
  );
});
